/** The words of the story-level View SQL dialog. */
export const storySqlDialogCopy = {
  title: "SQL behind this story",
  modelSuffix: (name: string) => `${name} data model`,
  tiles: (count: number) => `${count} ${count === 1 ? "tile" : "tiles"}`,
  close: "Close",
  listLabel: "Charts in this story",
  searchLabel: "Search charts",
  searchPlaceholder: "Search charts",
  compare: "Compare several",
  withSql: (count: number) =>
    `${count} ${count === 1 ? "chart" : "charts"} with SQL`,
  allCharts: "All charts",
  groupByPage: "Group by page",
  groupLabel: "Group charts",
  groupByTag: "Tagged by",
  noTag: "No tag",
  needsPages: "Add a second page to group by page",
  needsTags: "Tag a chart to group by tag",
  soon: "Coming soon",
  layoutLabel: "Layout",
  both: "Both",
  readable: "Readable",
  engine: "Engine",
  readablePane: "What this chart asks for",
  readableHint: "business names · comments",
  enginePane: "Sent to the query engine",
  engineHint: "engine dialect · after filters",
  readableTag: "Readable",
  engineTag: "Engine",
  engineUnavailable: "There is no engine SQL to show for this chart.",
  engineExpired: "The engine SQL is no longer held. Reopen this dialog to run the chart again.",
  engineTruncated: "The statement was cut at the length the service returns.",
  downloadFailed: "Could not save the SQL file. Try again.",
  downloading: "Preparing…",
  downloadAll: "Download all .sql",
  noQuery: "No query",
  copy: "Copy",
  copied: "Copied",
  loading: "Loading SQL…",
  empty: "Pick a chart to see its query.",
  noCharts: "This story has no charts with SQL.",
  note: "The chart's own query, before any filters or drills.",
  comparePick: "Tick two charts to compare them.",
  parameters: "Parameters",
  parameterChip: (name: string, value: string) => `${name} = ${value}`,
  rowLevelSecurityApplied: "Row-level security applied",
  maskedColumnsExcluded: (count: number) =>
    `${count} masked ${count === 1 ? "column" : "columns"} excluded`,
} as const;
